const item = Object.freeze({
  Available: 1,
  NotAvailable: 2,
  Assigned: 3,
  PendingTransfer: 4,
  Reserved: 5,
  Inactive: 6,
  Confiscated: 7,
  Processed: 8,
  Loan: 9,
  Donated: 10,
  Returned: 11,
  PendingReturn: 12,
});
export default item;
